import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { CarProvider } from './context/CarContext';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Home from './pages/Home';
import AdminDashboard from './pages/AdminDashboard';
import CarDetails from './pages/CarDetails';
import Login from './pages/Login';
import GoogleCloudStorageTest from './components/GoogleCloudStorageTest';
import FirestoreTest from './components/FirestoreTest';

function App() {
  return (
    <AuthProvider>
      <CarProvider>
        <Router>
          <div className="min-h-screen bg-gray-900">
            <Header />
            <main className="container mx-auto px-4 py-8">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/car/:id" element={<CarDetails />} />
                <Route path="/login" element={<Login />} />
                <Route path="/gcs-test" element={<GoogleCloudStorageTest />} />
                <Route path="/firestore-test" element={<FirestoreTest />} />
              </Routes>
            </main>
            <Toaster 
              position="top-right"
              toastOptions={{
                duration: 3000,
                style: {
                  background: '#fff',
                  color: '#374151',
                  borderRadius: '10px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                },
              }}
            />
          </div>
        </Router>
      </CarProvider>
    </AuthProvider>
  );
}

export default App;